
const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

const handleExportRequest = async (url, filename) => {
  try {
    const token = localStorage.getItem("token");
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(`/api/exports/${url}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      let message = "Failed to export data";
      try {
        const errorData = await response.json();
        message = errorData.message || message;
      } catch (e) { /* ignore */ }
      throw new Error(message);
    }

    const blob = await response.blob();
    downloadBlob(blob, filename);
    return { success: true };
  } catch (error) {
    console.error("Export Service Error:", error);
    throw error;
  }
};

export const exportUsers = () => handleExportRequest("users", "Users_Export.xlsx");
export const exportSocieties = () => handleExportRequest("societies", "Societies_Export.xlsx");
export const exportBookings = () => handleExportRequest("bookings", "Bookings_Export.xlsx");
export const exportAuditLogs = () => handleExportRequest("audit-logs", "Audit_Logs_Export.xlsx");
